import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function ConfirmAttendanceModal({
  show,
  onClose,
  // activityId,
  activityName,
  onSubmit,
}) {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const inputsRef = useRef([]);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    document.body.style.overflow = show ? "hidden" : "auto";
    if (show && !success) {
      setTimeout(() => inputsRef.current[0]?.focus(), 200);
    }
  }, [show, success]);

  const resetOtp = () => setOtp(Array(6).fill(""));

  const handleClose = () => {
    resetOtp();
    setSuccess(false);
    onClose();
  };

  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;
    const updated = [...otp];
    updated[index] = value;
    setOtp(updated);

    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const submitHandler = async () => {
    const code = otp.join("");
    if (code.length !== 6) return;

    setLoading(true);
    setErrorMsg(""); // مسح أي رسالة قديمة

    const result = await onSubmit(code); // { success, message }

    setLoading(false);

    if (result.success) {
      setSuccess(true);
      resetOtp();
    } else {
      setErrorMsg(result.message); // عرض رسالة الخطأ
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay d-flex justify-content-center align-items-center">
      <div className="modal-animate bg-white rounded shadow-lg p-4 p-md-5 position-relative text-center modal-card">
        {!success && (
          <button
            className="btn-close position-absolute"
            style={{ top: 14, right: 14 }}
            onClick={handleClose}
            disabled={loading}
          />
        )}

        {!success ? (
          <>
            <h4 className="fw-bold text-primary mb-2">Confirm Attendance</h4>

            <div
              className="bg-light small rounded py-2 px-3 mt-1 mb-3 text-secondary"
              style={{
                fontSize: "13px",
                borderLeft: "4px solid #0d6efd",
              }}
            >
              Please enter the code provided by the supervisor
            </div>

            <h6 className="fw-semibold text-dark mb-4">{activityName}</h6>

            <div className="d-flex justify-content-center gap-2 mb-4 otp-wrapper">
              {otp.map((digit, i) => (
                <input
                  key={i}
                  ref={(el) => (inputsRef.current[i] = el)}
                  type="text"
                  maxLength="1"
                  className="form-control text-center fw-bold shadow-sm otp-input"
                  style={{
                    width: "50px",
                    height: "55px",
                    fontSize: "20px",
                    borderColor: "#0d6efd",
                    transition: "0.2s",
                  }}
                  value={digit}
                  disabled={loading}
                  onChange={(e) => handleChange(e.target.value, i)}
                  onKeyDown={(e) => handleKeyDown(e, i)}
                />
              ))}
            </div>

            <div className="text-danger small mb-3">{errorMsg && errorMsg}</div>

            <button
              className="btn btn-primary w-100 fw-semibold py-2 d-flex align-items-center justify-content-center"
              onClick={submitHandler}
              disabled={loading}
            >
              {loading ? (
                <div className="spinner-border spinner-border-sm me-2"></div>
              ) : (
                "Submit"
              )}
            </button>
          </>
        ) : (
          <>
            <div className="text-success fs-1 mb-3">🤖</div>
            <h5 className="fw-bold text-success mb-2">Attendance confirmed!</h5>

            <p className="text-secondary small mb-4">
              You have successfully checked in for:
              <span className="fw-semibold text-dark rounded-5 d-block p-1 mt-1">
                "{activityName}"
              </span>
            </p>

            <button
              className="btn btn-success w-100 fw-semibold py-2"
              onClick={handleClose}
            >
              Done
            </button>
          </>
        )}
      </div>

      <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.65);
          z-index: 2000;
          animation: fadeIn 0.25s ease-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @media (max-width: 480px) {
          .otp-input {
            width: 42px !important;
            height: 50px !important;
            font-size: 18px !important;
          }
          .otp-wrapper {
            gap: 6px !important;
            flex-wrap: wrap !important;
          }
          .modal-card {
            width: 95% !important;
            padding: 20px !important;
          }
        }

        @media (max-width: 360px) {
          .otp-input {
            width: 38px !important;
            height: 45px !important;
            font-size: 16px !important;
          }
        }
      `}</style>
    </div>
  );
}
